/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Psp } from "./Psp";
import * as t from "io-ts";

// required attributes
const PspResponseR = t.interface({});

// optional attributes
const PspResponseO = t.partial({
  data: Psp
});

export const PspResponse = t.intersection(
  [PspResponseR, PspResponseO],
  "PspResponse"
);

export type PspResponse = t.TypeOf<typeof PspResponse>;
